import { Pagination } from '../styled'
import times from 'lodash/times'

export default function Paginagor({ onPageClick, totalPages, currentPage }) {
  const hasPreviousPage = currentPage !== 1
  const hasNextPage = totalPages > currentPage

  const pages = times(totalPages, index => {
    const pageIndex = index + 1
    const isActive = currentPage === pageIndex
    return (
      <Pagination.Button
        key={pageIndex}
        isActive={isActive}
        disabled={isActive}
        onClick={() => onPageClick(pageIndex)}
      >
        {pageIndex}
      </Pagination.Button>
    )
  })

  return (
    <Pagination>
      <Pagination.ButtonsWrapper>
        <Pagination.Button disabled={!hasPreviousPage} onClick={() => onPageClick(currentPage - 1)}>
          {'<'}
        </Pagination.Button>
        {pages}
        <Pagination.Button onClick={() => onPageClick(currentPage + 1)}>
          {'>'}
        </Pagination.Button>
      </Pagination.ButtonsWrapper>
    </Pagination>
  )
}
